import { Chip, Link } from "@mui/material";
import {
  FunctionField,
  NumberField,
  RaRecord,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { formatDateTime } from "../../utils/DateTimeUtils";
import { getReferenceName } from "../../utils/walletTransactionReference";

const WalletTransactionMetaShow = (props: any) => {
  return (
    <Show {...props} actions={false}>
      <SimpleShowLayout>
        <NumberField label="Id" source="id" />
        <TextField label="Wallet Id" source="userWalletId" />
        <TextField label="Notes" source="notes" />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Reference Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/${getReferenceName(record?.referenceModelName)}/${record?.referenceId}/show`}>
                    {record?.referenceId}
                </Link>
                );
        }} />
        <TextField label="Reference Model" source="referenceModelName" />
        <TextField label="Notes" source="notes" />
        <FunctionField label="Payment Status" render={(record: any) => (
            <Chip
                label={record?.isPaid ? "Paid" : "Not Paid"}
                color={record?.isPaid ? "success" : "error"}
                size="small"
            />
        )} />
        <FunctionField label="Created At" render={(record: any) => record?.createdAt ? formatDateTime(record.createdAt) : '-'} />
        <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? formatDateTime(record.updatedAt) : '-'} />  
      </SimpleShowLayout>
    </Show>
  );
};

export default WalletTransactionMetaShow;
